import React from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { connect } from 'react-redux';
import eventTracker from '../../../../helpers/eventTracker';
import { Button } from '../../components';
import events from '../../events';
import { cdnBaseUrl } from '../../../../app/apis';
import {
  HorizontalBullet, LeftArrow, OpacityAnimation, RightArrow
} from '../../../../styles/common-styles';

const FLCarousel = ({
  flIndex,
  featured_lessons,
  setFlIndex,
  openFlHandler,
  windowsWidth,
  templateColors
}) => {
  const {
    campaign_nm,
    notes,
    campaign_cover
  } = featured_lessons[flIndex];
  const { main_color } = templateColors;

  const leftButtonClickHandler = () => {
    setFlIndex((prevState) => prevState - 1);
    eventTracker(
      events.HOME_SCREEN_MATERIAL_SPOTLIGHT_BACK_BTN_TAP,
      { material_id: featured_lessons[flIndex - 1].mat_id }
    );
  };

  const rightButtonClickHandler = () => {
    setFlIndex((prevState) => prevState + 1);
    eventTracker(
      events.HOME_SCREEN_MATERIAL_SPOTLIGHT_NEXT_BTN_TAP,
      { material_id: featured_lessons[flIndex + 1].mat_id }
    );
  };

  return (
    <>
      <MaterialItemContainer
        key={flIndex}
        onClick={openFlHandler}
        windowsWidth={windowsWidth}
      >
        <ImageContainer>
          <Image
            src={`${cdnBaseUrl}/campaigns/${campaign_cover}`}
            alt="blog-galery"
            height="140px"
          />
        </ImageContainer>
        <ContextContainer>
          <ContextCategoryHeader>
            {campaign_nm.replace(/<[^>]+>/g, '')}
          </ContextCategoryHeader>
          <SMSummary>
            {notes
              .replace(/<[^>]+>/g, '')
              .replaceAll('&amp;', '&')
              .replaceAll('&#160;', ' ')}
          </SMSummary>
          <Button
            mainColor={main_color || false}
            onClick={openFlHandler}
            margin="30px 0 0 auto"
            aria-label={`Find out, ${campaign_nm}`}
          >
            {_('homePage.learn_more')}
          </Button>
        </ContextContainer>
      </MaterialItemContainer>
      <Carousel>
        {featured_lessons.map((bullet, bulletIndex) => (
          <HorizontalBullet
            onClick={() => setFlIndex(bulletIndex)}
            isCurrentSlide={flIndex === bulletIndex}
          />
        ))}
      </Carousel>
      <LeftArrow
        disabled={flIndex === 0}
        onClick={leftButtonClickHandler}
        aria-label="Previous"
      >
        &#8678;
      </LeftArrow>
      <RightArrow
        disabled={flIndex === featured_lessons.length - 1}
        onClick={rightButtonClickHandler}
        aria-label="Next"
      >
        &#8680;
      </RightArrow>
    </>
  );
};

export default connect((store) => ({
  templateColors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
}), null)(FLCarousel);

const MaterialItemContainer = styled.div`
  display: flex;
  flex-direction: ${({ windowsWidth }) => windowsWidth < 650 && 'column'};
  padding: 0 27px;
  margin: 0 18px;
  margin-bottom: 15px;
  transition: all 0.3s;
  border-radius: 5px;
  z-index: 20000;
  animation: ${OpacityAnimation} 0.5s;
  cursor: pointer;
  
  &:hover {
    transition: all 0.3s;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;

const Image = styled.img`
  max-width: ${({ height }) => `${height}`};
  height: ${({ height }) => `${height}`};
  border-radius: 3px;
  object-fit: cover;
`;

const ContextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 10px !important;
  padding: 10px 0;
  overflow: hidden;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextCategoryHeader = styled.h3`
  margin: 0 !important;
  padding-bottom: 10px !important;
  font-size: 18px !important;
  color: #387AA8 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif !important;
`;

const SMSummary = styled.div`
  width: 100%;
  color: #404040;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
  opacity: 0.8;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  line-clamp: 5;
  -webkit-box-orient: vertical;
`;

const Carousel = styled.div`
  display: flex;
  justify-content: center;
`;
